import { render, staticRenderFns } from "./TextAnswer.vue?vue&type=template&id=26fff30b&scoped=true&"
import script from "./TextAnswer.vue?vue&type=script&lang=ts&"
export * from "./TextAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./TextAnswer.vue?vue&type=style&index=0&id=26fff30b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fff30b",
  null
  
)

export default component.exports